// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"1de4a5d2","486":"4c0a084b","592":"e21abad0"}[chunkId] + ".chunk.js";
};